export default "__VITE_ASSET__BJ87qZ8e__"